import * as React from 'react';

import Inquiry from '@app/components/UI/Inquiry/Inquiry';

import bannerMobile from '@images/Body_contouring_2_mobile.jpeg';
import banner from '@images/Body_contouring_2.jpeg';

const FooterInquiryForm: React.FC = () => {
	return (<>
		<div className="extra-text-block" id="booking" style={{ margin: 0 }}>
			<h2>
				Schedule
			</h2>
			<h3 className="text-center">
				We will get in touch with you as soon as possible
			</h3>
		</div>
		<div className="top-banner" id="home" style={{ maxHeight: '700px' }}>
			<div className="image-block">
				<picture>
					<source media="(max-width: 768px)" srcSet={bannerMobile} />
					<source media="(min-width: 769px)" srcSet={banner} />
					<img className="top-banner__image" alt="banner" srcSet={banner} />
				</picture>
				<div className="content-block">
					<div className="inquiry-form">
						<Inquiry title="" className="inquiry-wrapper-mobile" />
					</div>
				</div>
			</div>
		</div>
	</>);
};

export default FooterInquiryForm;
